import { reactive } from 'vue'
import {
  DEFAULT_RETAILER_CODE,
  RETAILER_CODE_STORAGE_KEY,
  RETAILER_CONFIGS,
  RetailerConfig,
} from '@/constants/retail'

function getCurrentRetailerConfig(): RetailerConfig {
  const retailerCode = localStorage?.getItem(RETAILER_CODE_STORAGE_KEY)
  return RETAILER_CONFIGS[retailerCode || ''] ?? RETAILER_CONFIGS[DEFAULT_RETAILER_CODE]
}

const retailerState = reactive({
  config: getCurrentRetailerConfig(),
  version: 0,
})

export function setRetailer(retailerCode: string): boolean {
  if (!retailerCode || retailerState.config?.code === retailerCode) {
    return false
  }

  localStorage.setItem(RETAILER_CODE_STORAGE_KEY, retailerCode)
  retailerState.config = getCurrentRetailerConfig()
  retailerState.version += 1
  return true
}

export default retailerState
